import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { TableLazyLoadEvent } from 'primeng/table';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { MenuItem } from 'primeng/api';
import { NXDataSourcePrime } from '../../../services/dataSource/NXDataSourcePrime';
import { TaskType } from '../../../task/entities/taskType';
import { Observable, of, switchMap, take } from 'rxjs';
import { ApolloService } from '../../../services/apollo.service';
import * as fromGraphQl from './graphql';
import { Reloadable } from '../../../services/command/command.service';
import { TaskTypesDataSource } from './task-types.datasource';

@Component({
  selector: 'app-task-types',
  templateUrl: './task-types.component.html',
  styleUrls: ['./task-types.component.scss']
})
export class TaskTypesComponent implements OnInit, Reloadable {

  dialogRef: DynamicDialogRef | undefined;

  public sortProperty: string;
  public defaultSortProperty: string = 'id';
  public sortDirection: string;
  public defaultSortDirection: string = 'asc';
  public pageNumber = 0;
  public pageSize = 15;
  // public sortModel = { label: 'Keine Sortierung', fieldName: 'id', direction: "asc" };
  // public sortOptions = [
  //   { label: 'coreModuleModule.subscriptionsComponent.list.sorting.noSorting', fieldName: 'id', direction: "asc" },
  //   { label: 'coreModuleModule.subscriptionsComponent.list.sorting.lastTriggeredDateTimeDesc', fieldName: 'lastTriggeredDateTime', direction: "desc" },
  //   { label: 'coreModuleModule.subscriptionsComponent.list.sorting.lastTriggeredDateTimeAsc', fieldName: 'lastTriggeredDateTime', direction: "asc" }
  // ];

  public dataSource: TaskTypesDataSource;
  public loading = false;
  public menuItems: MenuItem[] = [];
  public taskTypes: TaskType[];
  public selectedTaskType: TaskType | undefined;

  public customHeadersArray: Array<{ name: string, value: string }>;

  public reloadable = this;

  // ace config so that it only takes the hight of the content
  editorConfig = {
    maxLines: Infinity,
    highlightActiveLine: false,
    highlightGutterLine: false
  }

  constructor(
    private apollo: Apollo,
    @Inject('env') public environment: any,
    private cdRef: ChangeDetectorRef,
    private apolloService: ApolloService
  ) {
  }

  reload(): void {

  }

  ngOnInit(): void {
    this.dataSource = new TaskTypesDataSource(this.apollo, this.environment, this);
    this.dataSource.loading.subscribe((loading) => {
      this.loading = loading;
    });
    this.dataSource.loadIssueTypes({
    });
  }

  refetchEvents(): void {

  }

  loadData(event: TableLazyLoadEvent) {
    this.loading = true;

    // sorting
    if (event?.sortField !== undefined && typeof event?.sortField == 'string') {
      this.sortProperty = event.sortField;
    }
    if (event?.sortOrder !== undefined) {
      this.sortDirection = event.sortOrder === 1 ? 'asc' : 'desc';
    }

    // pagination
    this.pageNumber = event?.first !== undefined ? event.first / event.rows : 0;
    this.pageSize = event?.rows !== undefined ? event.rows : 15;

    this.refetchEvents();
  }

  sort(event: any) {
    if (event?.value?.direction && event?.value?.fieldName) {
      this.sortProperty = event.value.fieldName;
      this.sortDirection = event.value.direction;
    } else {
      this.sortProperty = this.defaultSortProperty;
      this.sortDirection = this.defaultSortDirection;
    }
    this.cdRef.detectChanges();
  }

  translateSortDirectionToSortOrder(sortDirection: string): number {
    return NXDataSourcePrime.translateSortDirectionToSortOrder(sortDirection);
  }

  copyToClipboard(stringToCopy: string): void {
    navigator.clipboard.writeText(stringToCopy);
  }


  setMenuItems(): void {
    this.menuItems = [];
  }

  // public getIssueTypes(): Observable<IssueType[]> {
  //   return this.apolloService.query<fromGraphQl.IssueTypesQueryResponse>(fromGraphQl.ISSUETYPES_QUERY)
  //     .pipe(
  //       take(1),
  //       switchMap( (result) => {
  //         return of( IssueType.createIssueTypes(result.data.issueTypes));
  //       })
  //     );
  // }


}
